var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"menu"},_vm._l((_vm.menuList),function(item,index){return _c('div',{key:index,class:['btn', item.active ? 'active' : ''],on:{"click":function($event){return _vm.toMenu(item)}}},[_c('span',[_vm._v(_vm._s(item.name))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }